import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const PlayIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="play" ref={ref as any} {...props}>
      <path
        d="M16.7933 11.3543L10.1477 6.5235C9.90379 6.34671 9.58003 6.32009 9.31271 6.45747C9.04327 6.59379 8.875 6.87069 8.875 7.16996V16.8284C8.875 17.1309 9.04327 17.4067 9.31271 17.543C9.42667 17.6006 9.55127 17.6293 9.67694 17.6293C9.84095 17.6293 10.0071 17.5771 10.1477 17.4738L16.7933 12.6472C17.0031 12.4928 17.1255 12.2543 17.1255 12.0008C17.1266 11.7431 17.0009 11.5056 16.7933 11.3543Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
});
